// See https://dom.spec.whatwg.org/#dom-node-nodetype
export const ELEMENT_NODE = 1;
export const TEXT_NODE = 3;
